const endpoints = {
	getUserSignature: '/signing/getUserSignature',
	requestSignPin: '/signing/requestSignPin',
	signWithPin: '/signing/signWithPin',
}
export {endpoints}